if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);

        this.fetchAvailability(this.dataset.variantId);

        this.variantChangeUnsubscriber = undefined;

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const variant = event.data.variant;

            if (!variant || !variant.id) return;

            this.dataset.variantId = variant.id;
            this.fetchAvailability(variant.id);
          });
        }
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      fetchAvailability(variantId) {
        let rootUrl = this.dataset.rootUrl;

        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }

        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');

            this.renderPreview(sectionInnerHTML);
          })
          .catch(() => {
            const button = this.querySelector('button');

            if (button) {
              button.removeEventListener('click', this.onClickRefreshList);
            }

            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        const button = this.querySelector('button');

        if (button) {
          button.addEventListener('click', this.onClickRefreshList);
        }
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');

        if (drawer) {
          drawer.remove();
        }

        const preview = sectionInnerHTML.querySelector('pickup-availability-preview');
        const newDrawer = sectionInnerHTML.querySelector('pickup-availability-drawer');

        if (!preview) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = preview.outerHTML;
        this.setAttribute('available', '');

        if (newDrawer) {
          document.body.appendChild(newDrawer);
        }

        if (this.dataset.productPageColorScheme && document.querySelector('pickup-availability-drawer')) {
          const colorClassesToApply = this.dataset.productPageColorScheme.split(' ');

          colorClassesToApply.forEach((colorClass) => {
            document.querySelector('pickup-availability-drawer').classList.add(colorClass);
          });
        }

        const button = this.querySelector('button');

        if (button) {
          button.addEventListener('click', (event) => {
            document.querySelector('pickup-availability-drawer').show(event.target);
          });
        }
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button').addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(event) {
        const target = event.target;

        if (
          target !== this &&
          !target.closest('pickup-availability-drawer') &&
          target.id !== 'ShowPickupAvailabilityDrawer'
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
      }
    }
  );
}